const ITEMS = [
  "Custom Website Design",
  "Expertly Developed",
  "SEO-Ready",
  "Mobile-First",
  "Launched in Under a Week",
  "Book a Free Call",
  "(507) 841-1801",
  "Fully Managed Hosting",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-[#050816] py-5" data-testid="marquee-strip">
      <div className="animate-marquee-slow flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg font-semibold tracking-tight text-slate-200 whitespace-nowrap">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-blue-600" />
          </span>
        ))}
      </div>
    </div>
  );
}
